import { Link } from '@tonic-one/react';
import { useToggle } from '@tonic-one/react-hooks';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import DownloadSummaryReportModal from '../DownloadSummaryReportModal';
import SmartTooltip from '@Report/SmartTooltip';

interface Props {
  // logItem: {
  //   fileSha1?: string;
  //   ddaaasRiskLevelKey?: string;
  //   scanSource?: string;
  //   [k: string]: string | undefined;
  // };
  logItem: any;
}

export function FileVaSummary({ logItem }: Props) {
  const { t } = useTranslation('log');
  const [isOpen, toggleIsOpen] = useToggle(false);
  if (
    logItem['fileSha1'] &&
    ['Low Risk', 'Medium Risk', 'High Risk'].includes(
      logItem['ddaaasRiskLevelKey'] as string
    ) &&
    logItem['scanSource'] !== 'Exchange Server'
  ) {
    return (
      <>
        <Link
          href="#"
          rel="noopener noreferrer"
          onClick={toggleIsOpen}
          width="100%"
        >
          <SmartTooltip>{t('log.fileVaSummary.downloadReport')}</SmartTooltip>
        </Link>
        {isOpen && (
          <DownloadSummaryReportModal
            visible={isOpen}
            onClose={toggleIsOpen}
            summaryReportParams={{
              language: i18next.language,
              reportId: logItem['fileSha1'],
              ddaDetectionType: logItem['ddaaasScanType'],
              tmDDAaasAnalysisMode:
                logItem['ddaaasAnalysisMode'] === 'UNKOWN'
                  ? 'DDAaaS & DDCloud & SBaaS'
                  : logItem['ddaaasAnalysisMode'],
              tmFileName: logItem['fileName'],
            }}
          />
        )}
      </>
    );
  }

  return <SmartTooltip>{logItem['fileVaSummary'] || ''}</SmartTooltip>;
}
